module.exports = require("@adobe/cq-spa-page-model-manager");